export let baseUrl = "http://leaf.ticketsimply.com/operator/api/";

export const API = {
  Allapi: {
    getDestinations: "destination_pairs.json",
    getRoutes: "available_routes",
  },
};
